import { Endpoint } from '../endpoint';

export const ElementVersion = new Endpoint('element_version');

// Add metadata method to get unique categories and owners
ElementVersion.metadata = async function() {
  return this.customRequest('element_version/metadata');
};
